// extracted by mini-css-extract-plugin
export default {"container":"ik-z","blurb":"jk-z","links":"kk-z"};